import { useCallback } from 'react';
import FormattedName from 'I18n/components/FormattedName';
// @ts-expect-error untyped module reference-resolvers
import { USER } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module customer-data-reference-ui-components
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
import SkeletonText from 'automation-ui-core/components/SkeletonText';
// @ts-expect-error untyped module customer-data-reference-ui-components
import UnknownName from 'customer-data-reference-ui-components/name/UnknownName';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Example:
 *   <UserName id="123" email="foo@example.com" />
 * Renders as:
 *   Firstname Lastname
 */
const UserName = ({
  id,
  email,
  href,
  messageKey
}) => /*#__PURE__*/_jsx(ReferenceName, {
  id: id,
  referenceObjectType: USER,
  onLoading: useCallback(() => email ? /*#__PURE__*/_jsx(FormattedName, {
    email: email
  }) : /*#__PURE__*/_jsx(SkeletonText, {}), [email]),
  onError: useCallback(() => email ? /*#__PURE__*/_jsx(FormattedName, {
    email: email
  }) : /*#__PURE__*/_jsx(UnknownName, {
    referenceObjectType: USER
  }), [email]),
  onResolved: useCallback(({
    reference
  }) => {
    const {
      firstName,
      lastName,
      email: resolvedEmail
    } = reference.referencedObject.toJS();
    return /*#__PURE__*/_jsx(FormattedName, {
      givenName: firstName,
      familyName: lastName,
      email: resolvedEmail
    });
  }, [])
  // NOTE: no default href because HubSpot has no direct url to view a user
  //       (just /settings/:portalId/users)
  //       See https://git.hubteam.com/HubSpot/CRM-Issues/issues/2735
  ,
  href: href,
  messageKey: messageKey
});
export default UserName;